import { Injectable } from '@angular/core';
import { QuestionCategory } from "../../common/models/question-category";
import { Observable } from "rxjs";
import { ApiBaseService } from "../../common/providers/api-base-service";
import { map } from "rxjs/operators";
import { CurrentUser } from '../../common/providers/current-user';

@Injectable({providedIn: 'root'})
export class EvaluationAthleteQuestionCategoryProvider {
    constructor(
      private api: ApiBaseService,
      private currentUser: CurrentUser,
    ) {}

    /**
     * Find all Question Categories
     */
    public findAlll(): Observable<QuestionCategory[]> {
      return this.api.call('GET', 'nosync/common-data/question-categories', {}, this.currentUser.getAccessToken()).pipe(
        map((data: any) => {
          return QuestionCategory.fromAPIList(data);
        }),
      );
    }
}
